import { SheetRenderer } from "@/components/r3f/renderers/sheet-renderer";
import { SheetObject } from "@/object-cache";
import { FloorPlanBackgroundTransparency } from "@faro-lotv/lotv";
import { JSX } from "react";

type FlyWalkSheetsRendererProps = {
  /** The current active sheets */
  sheets: Array<SheetObject | undefined>;
};

/** @returns A component that renders all sheets in fly walk mode */
export function FlyWalkSheetsRenderer({
  sheets,
}: FlyWalkSheetsRendererProps): JSX.Element | null {
  return (
    <>
      {sheets.map(
        (sheet, index) =>
          sheet && (
            <SheetRenderer
              sheet={sheet}
              backgroundTransparent={FloorPlanBackgroundTransparency.Alpha}
              key={sheet.iElement.id}
              index={index}
            />
          ),
      )}
    </>
  );
}
